export const DEFAULT_OTP_LENGTH = 6;
export const VONAGE_VERIFY_OTP_LENGTH = 4;

export function normaliseOtpLength(value, fallback = DEFAULT_OTP_LENGTH) {
    const parsed = Number(value);

    if (Number.isInteger(parsed) && parsed >= 4 && parsed <= 6) {
        return parsed;
    }

    return fallback;
}

export function getOtpLengthForChallenge(challenge = null, fallback = DEFAULT_OTP_LENGTH) {
    const explicitLength = normaliseOtpLength(
        challenge?.otpLength || challenge?.delivery?.codeLength,
        null
    );

    if (explicitLength) {
        return explicitLength;
    }

    const provider = String(challenge?.delivery?.provider || "").trim().toLowerCase();

    if (provider === "vonage-verify" || provider === "vonage-verify-v1") {
        return VONAGE_VERIFY_OTP_LENGTH;
    }

    return normaliseOtpLength(fallback);
}
